<template>
  <a :href="'http://' + fqdn" target="_blank">
    <v-list-item-title class="headline mb-1 title font-weight-bold hidden-md-and-up">
      {{ name }}
      <v-icon class="title-icon" right id="icon-style-pink">fas fa-external-link-alt</v-icon>
    </v-list-item-title>
  </a>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: [ 'name', 'fqdn' ]  
}
</script>

<style scoped>
a {
  text-decoration: none;
  color: #000 !important;
}
</style>